[
  {
    "_note": "Only effects with code behind them appear here. requiresTech names the technology needed before any city can build it (null: from the start). wallsDefence adds that percentage to a defender's strength in the city, except against siege units (ADR-0064). A field that does nothing is worse than a missing one. culture is points a turn toward the city's borders and its civilisation's prestige (ADR-0057). A wonder (\"wonder\": true) can be built once in the whole world; its \"effects\" apply to its own city and its \"civEffects\" to every city of whoever holds it.",
    "key": "granary",
    "name": "Granary",
    "cost": 40,
    "requiresTech": "pottery",
    "effects": {
      "growthFoodKept": 0.5
    },
    "description": "Stored grain carries a city through the season after it grows, instead of starting from nothing each time.",
    "upkeep": 1
  },
  {
    "key": "workshop",
    "name": "Workshop",
    "cost": 50,
    "requiresTech": "woodworking",
    "effects": {
      "productionBonus": 2
    },
    "description": "Smiths and joiners working to order. The city builds faster than its fields alone would allow.",
    "upkeep": 1
  },
  {
    "key": "market",
    "name": "Market",
    "cost": 50,
    "requiresTech": "currency",
    "effects": {
      "goldBonus": 2
    },
    "description": "A place to trade what the countryside cannot eat.",
    "upkeep": 1
  },
  {
    "key": "aqueduct",
    "name": "Aqueduct",
    "cost": 80,
    "requiresTech": "construction",
    "effects": {
      "sizeCapIncrease": 6
    },
    "description": "Water brought from beyond the walls. Until one is built, a city can only grow as far as its own wells allow.",
    "upkeep": 1
  },
  {
    "key": "palace",
    "name": "Palace",
    "cost": 0,
    "requiresTech": null,
    "upkeep": 0,
    "effects": {
      "isSeatOfGovernment": true,
      "contentment": 1,
      "culture": 1
    },
    "description": "The seat of government. Rule reaches outward from here and thins with distance, so where it stands shapes an empire as much as how large that empire is."
  },
  {
    "key": "courthouse",
    "name": "Courthouse",
    "cost": 60,
    "requiresTech": "code_of_laws",
    "upkeep": 1,
    "effects": {
      "dragReduction": 0.5
    },
    "description": "Local magistrates who answer to the capital. Half of what distance would otherwise swallow reaches the treasury instead."
  },
  {
    "key": "temple",
    "name": "Temple",
    "cost": 40,
    "requiresTech": "ritual",
    "upkeep": 1,
    "effects": {
      "contentment": 2,
      "culture": 1
    },
    "description": "Somewhere for a crowded city to put its faith, and its grievances."
  },
  {
    "key": "library",
    "name": "Library",
    "cost": 60,
    "requiresTech": "writing",
    "upkeep": 1,
    "effects": {
      "sciencePercent": 50,
      "culture": 1
    },
    "description": "Records kept, copied and consulted. Half as much again of the city's science."
  },
  {
    "key": "forge",
    "name": "Forge",
    "cost": 70,
    "requiresTech": "iron_working",
    "upkeep": 1,
    "effects": {
      "productionBonus": 2
    },
    "description": "Charcoal, bellows and anvils: tools and fittings made here rather than traded for."
  },
  {
    "key": "amphitheatre",
    "name": "Amphitheatre",
    "cost": 70,
    "requiresTech": "drama",
    "upkeep": 1,
    "effects": {
      "contentment": 3,
      "culture": 2
    },
    "description": "Plays, contests and spectacle for a crowded city."
  },
  {
    "key": "observatory",
    "name": "Observatory",
    "cost": 90,
    "requiresTech": "astronomy",
    "upkeep": 1,
    "effects": {
      "sciencePercent": 25,
      "culture": 1
    },
    "description": "Instruments aligned to the heavens, and scholars to read them."
  },
  {
    "key": "cathedral",
    "name": "Cathedral",
    "cost": 110,
    "requiresTech": "monotheism",
    "upkeep": 2,
    "effects": {
      "contentment": 3,
      "culture": 2
    },
    "description": "A monument to faith that takes generations to finish, and keeps a great city at peace."
  },
  {
    "key": "university",
    "name": "University",
    "cost": 130,
    "requiresTech": "scholasticism",
    "upkeep": 2,
    "effects": {
      "sciencePercent": 50,
      "culture": 2
    },
    "description": "Masters, students and a library to argue over."
  },
  {
    "key": "bank",
    "name": "Bank",
    "cost": 90,
    "requiresTech": "banking",
    "upkeep": 1,
    "effects": {
      "goldBonus": 3
    },
    "description": "Deposits, loans and letters of credit. Coin works while it waits."
  },
  {
    "key": "sewer",
    "name": "Sewer",
    "cost": 140,
    "requiresTech": "germ_theory",
    "upkeep": 1,
    "effects": {
      "sizeCapIncrease": 8
    },
    "description": "Clean water in, foul water out. A city can grow past the size where disease stopped it."
  },
  {
    "key": "factory",
    "name": "Factory",
    "cost": 180,
    "requiresTech": "industrialisation",
    "upkeep": 3,
    "effects": {
      "productionBonus": 6
    },
    "description": "Machines, shifts and a chimney. Output no workshop could match."
  },
  {
    "key": "power_plant",
    "name": "Power Plant",
    "cost": 160,
    "requiresTech": "electricity",
    "upkeep": 2,
    "effects": {
      "productionBonus": 4
    },
    "description": "Current for every machine in the city."
  },
  {
    "key": "stock_exchange",
    "name": "Stock Exchange",
    "cost": 150,
    "requiresTech": "the_corporation",
    "upkeep": 1,
    "effects": {
      "goldBonus": 6
    },
    "description": "Shares in anything, traded all day."
  },
  {
    "key": "research_lab",
    "name": "Research Laboratory",
    "cost": 200,
    "requiresTech": "computers",
    "upkeep": 2,
    "effects": {
      "sciencePercent": 50,
      "culture": 1
    },
    "description": "Teams, funding and equipment no single scholar could command."
  },
  {
    "key": "barracks",
    "name": "Barracks",
    "cost": 40,
    "requiresTech": "bronze_working",
    "effects": {
      "veteranUnits": true
    },
    "description": "Drill yards and armouries. Soldiers and sailors trained here begin as Veterans.",
    "upkeep": 1
  },
  {
    "key": "city_walls",
    "name": "City Walls",
    "cost": 40,
    "requiresTech": "masonry",
    "upkeep": 0,
    "effects": {
      "wallsDefence": 100
    },
    "description": "Stone curtain walls and gatehouses. Defenders count double against every attacker but siege engines, which were built for exactly this."
  },
  {
    "key": "anti_aircraft",
    "name": "Anti-Aircraft Battery",
    "cost": 70,
    "requiresTech": "radio",
    "upkeep": 1,
    "effects": {
      "antiAir": 30
    },
    "description": "Guns and searchlights ringing the city. Every air strike on it runs a gauntlet of fire before it can drop a bomb."
  },
  {
    "key": "ziggurat_of_ur",
    "name": "Ziggurat of Ur",
    "cost": 140,
    "upkeep": 0,
    "requiresTech": "priesthood",
    "wonder": true,
    "effects": {
      "culture": 3
    },
    "civEffects": {
      "contentment": 1
    },
    "description": "A stepped temple-mountain raised to the moon god. One more content citizen in every city you hold."
  },
  {
    "key": "library_of_ashurbanipal",
    "name": "Library of Ashurbanipal",
    "cost": 150,
    "upkeep": 0,
    "requiresTech": "writing",
    "wonder": true,
    "effects": {
      "culture": 3,
      "sciencePercent": 50
    },
    "civEffects": {
      "sciencePercent": 10
    },
    "description": "Tens of thousands of clay tablets gathered by a scholar-king. +50% science here and +10% in every city."
  },
  {
    "key": "terracotta_army",
    "name": "Terracotta Army",
    "cost": 200,
    "upkeep": 0,
    "requiresTech": "standing_army",
    "wonder": true,
    "effects": {
      "culture": 2
    },
    "civEffects": {
      "veteranUnits": true
    },
    "description": "An army of clay to guard an emperor for ever. Every city you hold trains its units as Veterans."
  },
  {
    "key": "theatre_of_epidaurus",
    "name": "Theatre of Epidaurus",
    "cost": 200,
    "upkeep": 0,
    "requiresTech": "drama",
    "wonder": true,
    "effects": {
      "culture": 5,
      "contentment": 4
    },
    "civEffects": {},
    "description": "A great stone theatre famed for carrying a whisper to the back row. Four content citizens here, and a great deal of culture."
  },
  {
    "key": "house_of_wisdom",
    "name": "House of Wisdom",
    "cost": 300,
    "upkeep": 0,
    "requiresTech": "scholasticism",
    "wonder": true,
    "effects": {
      "culture": 4,
      "sciencePercent": 50
    },
    "civEffects": {
      "sciencePercent": 15
    },
    "description": "A house of translators and astronomers where the learning of many peoples met. +50% science here and +15% in every city."
  },
  {
    "key": "angkor_wat",
    "name": "Angkor Wat",
    "cost": 320,
    "upkeep": 0,
    "requiresTech": "theology",
    "wonder": true,
    "effects": {
      "culture": 5
    },
    "civEffects": {
      "culture": 1
    },
    "description": "A temple-city mirroring the shape of the cosmos. Every city you hold gains a point of culture each turn."
  },
  {
    "key": "grand_bazaar",
    "name": "Grand Bazaar",
    "cost": 400,
    "upkeep": 0,
    "requiresTech": "economics",
    "wonder": true,
    "effects": {
      "culture": 3,
      "goldBonus": 4
    },
    "civEffects": {
      "goldBonus": 1
    },
    "description": "A covered market of thousands of shops. +4 gold here and +1 gold in every city."
  },
  {
    "key": "crystal_palace",
    "name": "Crystal Palace",
    "cost": 600,
    "upkeep": 0,
    "requiresTech": "industrialisation",
    "wonder": true,
    "effects": {
      "culture": 4
    },
    "civEffects": {
      "productionBonus": 1
    },
    "description": "A hall of iron and glass built to show the works of the world. +1 production in every city."
  },
  {
    "key": "uraniborg",
    "name": "Uraniborg",
    "cost": 480,
    "upkeep": 0,
    "requiresTech": "heliocentrism",
    "wonder": true,
    "effects": {
      "culture": 3,
      "sciencePercent": 50
    },
    "civEffects": {
      "sciencePercent": 10
    },
    "description": "An island observatory whose instruments measured the heavens more exactly than any before. +50% science here and +10% in every city."
  },
  {
    "key": "st_peters_basilica",
    "name": "St Peter's Basilica",
    "cost": 500,
    "upkeep": 0,
    "requiresTech": "printing",
    "wonder": true,
    "effects": {
      "culture": 6,
      "contentment": 3
    },
    "civEffects": {
      "contentment": 1
    },
    "description": "A great domed basilica that took a century and many masters to raise. Three content citizens here and one more in every city you hold."
  },
  {
    "key": "venetian_arsenal",
    "name": "Venetian Arsenal",
    "cost": 520,
    "upkeep": 0,
    "requiresTech": "navigation",
    "wonder": true,
    "effects": {
      "culture": 2,
      "productionBonus": 5,
      "veteranUnits": true
    },
    "civEffects": {},
    "description": "A shipyard of a thousand workers said to finish a galley in a day. +5 production here, and its ships and soldiers start as Veterans."
  },
  {
    "key": "suez_canal",
    "name": "Suez Canal",
    "cost": 650,
    "upkeep": 0,
    "requiresTech": "the_corporation",
    "wonder": true,
    "effects": {
      "culture": 2,
      "goldBonus": 6
    },
    "civEffects": {
      "goldBonus": 1
    },
    "description": "A cut between two seas that shortened the world's trade routes by weeks. +6 gold here and +1 gold in every city."
  },
  {
    "key": "eiffel_tower",
    "name": "Eiffel Tower",
    "cost": 650,
    "upkeep": 0,
    "requiresTech": "electricity",
    "wonder": true,
    "effects": {
      "culture": 8
    },
    "civEffects": {
      "culture": 1
    },
    "description": "A lattice of wrought iron raised for a world's fair and never taken down. A great deal of culture here and a point more in every city."
  },
  {
    "key": "empire_state_building",
    "name": "Empire State Building",
    "cost": 850,
    "upkeep": 0,
    "requiresTech": "mass_production",
    "wonder": true,
    "effects": {
      "culture": 3,
      "productionBonus": 6,
      "goldBonus": 4
    },
    "civEffects": {
      "productionBonus": 1
    },
    "description": "A skyscraper built in little more than a year. +6 production and +4 gold here, and +1 production in every city."
  },
  {
    "key": "sydney_opera_house",
    "name": "Sydney Opera House",
    "cost": 900,
    "upkeep": 0,
    "requiresTech": "electronics",
    "wonder": true,
    "effects": {
      "culture": 8,
      "contentment": 4
    },
    "civEffects": {
      "contentment": 1
    },
    "description": "Shells of white tile on a harbour point. Four content citizens and a great deal of culture here, and one more content citizen in every city."
  },
  {
    "key": "cern",
    "name": "CERN",
    "cost": 1000,
    "upkeep": 0,
    "requiresTech": "computers",
    "wonder": true,
    "effects": {
      "culture": 4,
      "sciencePercent": 100
    },
    "civEffects": {
      "sciencePercent": 15
    },
    "description": "A laboratory where many nations share the largest machines ever built to study matter. +100% science here and +15% in every city."
  }
]
